export default import.meta.ROLLDOWN_FILE_URL_CK2t_1wfBPe87vAqL_l2Fg